import Box from '@mui/material/Box'
import { CSSProperties } from 'react'

interface Props {
  text: string
}

/**
 * 付加情報のタグを表示するコンポーネント
 * 丸いラベルのような見た目
 */
export default function LineTagComponent(props: Props) {
  return <Box style={tagStyle}>{props.text}</Box>
}

const tagStyle: CSSProperties = {
  color: 'white',
  backgroundColor: '#5f6e6e',
  fontSize: 14,
  padding: '2px 12px',
  width: 'fit-content',
  borderRadius: '9999px', // 楕円にする
}
